/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './animation048.less';

import ImgPoint from '../../../../../assets/animation_point.gif';

const bgTemplate = ['#C53B1C', '#A3300C', '#F26927', '#E71D2A', '#E78A00'];

const getBG = (feed: number) => bgTemplate[feed % bgTemplate.length];

interface IAnimation048Props {
  items: string[];
  onCompleted?: () => void;
  className?: string;
}

const Animation048: React.FunctionComponent<IAnimation048Props> = ({
  className,
  items,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      onCompleted && onCompleted();
    }
  };

  const rowCount = items.length <= 5 ? items.length : 5;

  return (
    <div ref={crrRef} className={`animation048 component ${className}`}>
      <div className="animation048-content">
        {items.map((itm: string, idx: number) => (
          <div
            key={idx}
            className={`animation048-item  r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
            style={{
              width: `calc(${(1 / rowCount) * 100}% - 1rem)`,
              backgroundColor: getBG(idx),
            }}
          >
            <img
              className={`click-point ${play > 1 ? 'hide' : ''}`}
              src={ImgPoint}
              alt=""
            />
            <div
              className="animation048-text"
              dangerouslySetInnerHTML={{ __html: itm }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation048;
